var Core     = require('../core/core.js');

/**
 * TrayTabContent
 */

class TrayTabContent extends Core  {

    constructor(options) {
        super(options);
    }

    render(override){
        super.render(override);
    }

    /*
     * Clears everything
    */

    clear(){
        this.$el.empty();
    }

    /*
     * Clears the previous content
    */

    clearContent(){
        $('.js-editor__tray__content', this.$el).empty();
    }

    /**
     * Show the tray tab
     */
    show(){
        this.$el.show();
    }

    /**
     * Hide the tray tab
     */
    hide(){
        this.$el.hide();
    }


}

module.exports = TrayTabContent;